
import state from './moduleCampaignFieldsManagementState'
import mutations from './moduleCampaignFieldsManagementMutations'
import actions from './moduleCampaignFieldsManagementActions'
import getters from './moduleCampaignFieldsManagementGetters'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

